import type { Product, Promotion } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { useState } from 'react'
import Button from '../Button'
import ProductCard from '../ProductCard'

interface Props {
  data: Promotion | null
}

const itemsPerTime = 15

const Recommend = ({ data }: Props) => {
  const [itemsToshow, setItemsToShow] = useState(itemsPerTime)

  if (!data?.products?.length) return null

  const canLoadMore = itemsToshow < data.products.length

  return (
    <section className='recommend rounded-sm bg-white p-5'>
      <h2 className='text-2xl font-bold text-[#282828]'>
        {getTranslate(data.name)}
      </h2>
      <div className='recommend--content mt-3 grid grid-cols-1 gap-3 xs:grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 xxl:grid-cols-5'>
        {data.products.slice(0, itemsToshow).map((e: Product) => (
          <ProductCard
            key={e._id}
            product={e}
            className='border border-gray-300'
          />
        ))}
      </div>
      {canLoadMore && (
        <Button
          color='primary'
          variant='outlined'
          className='mx-auto mt-3 !rounded-sm'
          onClick={() => setItemsToShow(itemsToshow + itemsPerTime)}
        >
          Xem thêm
        </Button>
      )}
    </section>
  )
}
export default Recommend
